import React from 'react';
import { PropTypes } from 'prop-types';

import Progress from './Progress';
import { getStage } from '../utils/helpers';

/**
 * @param {Object} props
 * @return {*}
 * @constructor
 */
const BraFitFinder = ({ stageNumber, stages, unsuccessfulStage }) => (
  <div>
    <div>
      <Progress stageNumber={stageNumber + 1} />
      {getStage(stages, stageNumber) || unsuccessfulStage}
    </div>
    <span>
      <button className="backdrop" />
    </span>
  </div>
);

BraFitFinder.propTypes = {
  stages: PropTypes.array,
  stageNumber: PropTypes.number,
  unsuccessfulStage: PropTypes.object,
};

export default BraFitFinder;
